module.exports = __webpack_public_path__ + "img/510.01ed804d.jpg";